


































































import Vue from 'vue';

import {
  Component,
  Prop,
} from 'vue-property-decorator';

import {
  buildSupplierFingerprints,
  defaultTable,
  isDuplicateSheet as sheetIsDuplicate,
  normalizeSupplierId,
  SheetModel,
  WorkTypeModel,
} from '@/components/RatesPage/types';

import RatesTable from '@/components/RatesPage/RatesTable.vue';
import { isSupplierUnpublished } from '@/utils/supplierDisplay';
import _ from 'lodash';

@Component({
  components: {
    RatesTable,
  },
})
export default class RatesSheet extends Vue {
  @Prop({
    type: Object,
    default: false,
  }) readonly workType!: WorkTypeModel;

  @Prop()
  readonly suppliers!: any;

  @Prop({
    type: Array,
    default: () => [],
  }) readonly originalSupplierIds!: Array<number | string>;

  usedWorkType = this.workType;

  get availableSuppliers() {
    const original = new Set(
      (this.originalSupplierIds || []).map((id) => normalizeSupplierId(id)),
    );
    return this.suppliers.filter((supplier: any) => {
      const supplierId = normalizeSupplierId(supplier.id);
      const usedSomewhere = this.usedWorkType.sheets?.some((sheet: any) => (sheet.suppliers || []).some(
        (sId: unknown) => normalizeSupplierId(sId) === supplierId,
      ));
      if (usedSomewhere) {
        return false;
      }
      // новых снятых с публикации добавлять нельзя (Q2); уже бывшие в листе (original) —
      // можно вернуть до сохранения (Q1).
      if (isSupplierUnpublished(supplier) && !original.has(supplierId)) {
        return false;
      }
      return true;
    }).map((sup: any) => normalizeSupplierId(sup.id));
  }

  get supplierFingerprints(): Record<string, number[]> {
    return buildSupplierFingerprints(this.usedWorkType.sheets);
  }

  get canAddSheet(): boolean {
    return !(this.supplierFingerprints['']?.length);
  }

  get addSheetBlockedTooltip(): string {
    return 'Общая сетка уже добавлена';
  }

  isDuplicateSheet(sheet: SheetModel): boolean {
    return sheetIsDuplicate(sheet, this.usedWorkType.sheets);
  }

  refreshSuppliers(value: any) {
    this.$emit('refreshSuppliers', value);
  }

  deleteTariff(key: any) {
    if (this.usedWorkType?.sheets) {
      const item = this.usedWorkType.sheets.findIndex((v_rt: any) => v_rt.key === key.toString());
      this.$delete(this.usedWorkType.sheets, item);
    }
  }

  createSheet() {
    if (!this.canAddSheet) {
      this.$bus.$emit('notification', this.addSheetBlockedTooltip, 'warning');
      return;
    }

    /** TODO [m.kudryashov 15.04.2023 - 12:53]:
    * вынести в дефолтный sheet
    */
    const sheet = {
      cells: _.cloneDeep(defaultTable),
      key: Math.random().toString().substring(2),
      suppliers: [],
    };

    this.$emit('createRateTable', sheet);
  }

  changeRateTable(value: any) {
    this.$emit('changeRateTable', value);
  }

  updateComment(value: any) {
    this.$emit('updateComment', value);
  }
}

